define('modules/domain_listing/views/edit_domain_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/edit_domain_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  function stripUri(url) {
    var schemaless = url.replace(/^(http|https):/, "").split("/");
    return _.reduce(schemaless, function(domain, token){
      return domain || token;
    }, "");
  }

  function getSchema(url) {
    var schema = url.match(/^(https|http):\/\//);
    return schema && schema[0];
  }

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/edit_domain_popup"),
    triggers: {
      "click .js-cancel": "cancel"
    },
    events: {
      "click .js-ok": "save",
    },
    onRender: function(){
      this.$el.i18n();
    },
    save: function(e){
      var url = this.$(".js-url").val().trim();
      if(!url){
        this.$(".js-url").parent().addClass("has-error");
        this.$(".ed-help-block").removeClass("hidden");
      }
      else {
        this.trigger("save");
      }
    }
  },{
    show: function(domain) {
      var popup = new module.exports({model: domain}),
          defer = $.Deferred();
      popup.on("save", function() {
        var url = popup.$(".js-url").val(),
            schema = getSchema(url) || "http://",
            domainUrl = stripUri(url);
        defer.resolve(schema + domainUrl);
      });
      popup.on("cancel hide", defer.reject, defer);
      popup.on("save cancel", popup.hide, popup);
      return defer.promise();
    }
  });

});

